import axios from 'axios';
import { groupBy, mergeArrsByKey } from '@/helpers';

import { httpWithLoader } from '@/http-common';

const state = () => ({
    orkList: [], // Список рамок
    curOrkId: null // Текущий id рамки
});

const getters = {};

const mutations = {
    ADD_ORK(state, ork) {
        state.orkList.push(ork);
    },
    SET_ORK_LIST(state, orkList) {
        state.orkList = orkList;
    },
    SET_ORK_ID(state, curOrkId) {
        state.curOrkId = curOrkId;
    },
    DELETE_FROM_ORK_LIST(state, id) {
        const index = state.orkList.findIndex(el => el.id == id)
        state.orkList.splice(index, 1)
    },
    CHANGE_ORK(state, ork) {
        state.orkList = state.orkList.map(el => el.id === ork.id ? ork : el);
    }
};

const handleError = ((error, commit) => {

    if (error.response.status === 422) {
        // Это ошибка валидации
        console.log(error.response.data.errors);
        // console.log(Object.values(error.response.data.errors)[0]);
        commit('common/TOGGLE_ALERT', { open: true, status: 'error', text: Object.values(error.response.data.errors)[0][0] }, { root: true });
        return
    }

    commit('common/TOGGLE_ALERT', { open: true, status: 'error', text: `Что то пошло не так, пожалуйста перезагрузите страницу и попробуйте ещё раз` }, { root: true })
    // console.log(`url: ${ error.config ? error.config.url : '-' }\nmethod: ${ error.config ? error.config.method : '-' }\npayload: ${ error.config ? error.config.data : '-' }`);

    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        const tempMessage = error.response.data.trace.map(el => el.file).join('\n')
        console.log(`message: ${error.response.data.message}\nfiles:\n${tempMessage}`);
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the 
        // browser and an instance of
        // httpWithLoader.ClientRequest in node.js
        console.log(error.request);
    } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Ошибка', error.message);
    }
});

const actions = {
    // Получить ОРК
    async LOAD_ORK({ commit, rootState }) {
        await httpWithLoader.get(`/user/ork`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_ORK_LIST', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },
    async LOAD_ORK_BY_ID({ commit, rootState }, orkId) {
        return await httpWithLoader.get(`/user/ork/${ orkId }`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            return response.status
        })
        .catch((reject) => {
            handleError(reject, commit)

            return reject.response.status
        });
    },
    async CREATE_ORK({ commit, rootState }, params) {
        return await httpWithLoader.post(`/user/ork`, params,  {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('ADD_ORK', response.data);
            return response.data
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },
    async EDIT_ORK({ commit, rootState }, { id, params}) {
        await httpWithLoader.put(`/user/ork/${ id }`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('CHANGE_ORK', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },
    async DELETE_ORK({ commit, rootState }, orkId) {
        await httpWithLoader.delete(`/user/ork/${ orkId }`,  {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then(() => {
            commit('DELETE_FROM_ORK_LIST', orkId);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
